<fieldset>
  @if (controlsArray.length === 1) {
    <ng-container rsResolve [element]="controlsArray[0]"></ng-container>
  }
  @if (controlsArray.length > 1) {
    <rs-dropdown-consumer-group [controlsArray]="controlsArray"></rs-dropdown-consumer-group>
  }
</fieldset>